"use client";

import React from "react";

//Types
import { DropdownComponentProps } from "@/types";

//Styles
import * as S from "./styles";
import { ChevronDown } from "lucide-react";

const DropdownGroup: React.FC<DropdownComponentProps> = ({
  titleButton,
  titleDropdown,
  children,
  items,
  variant,
  width,
}) => {
  const allowedVariants = ["default", "danger", "warning", "success"] as const;
  const safeVariant: "default" | "danger" | "warning" | "success" | undefined =
    allowedVariants.includes(variant as any)
      ? (variant as "default" | "danger" | "warning" | "success")
      : undefined;

  return (
    <S.BoxDropdownGroup>
      {children}
      <S.DropdownBox>
        <S.DropdownButton $variant={safeVariant}>
          <ChevronDown />
        </S.DropdownButton>
        <S.Dropdown $width={width ?? "10.5rem"}>
          {titleDropdown && <S.DropdownTitle>{titleDropdown}</S.DropdownTitle>}
          <S.DropdownContent>
            {items &&
              items.map((item, idx) => (
                <S.DropdownItem key={idx}>
                  {item.link ? (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      {item.icon}
                      {item.label}
                    </a>
                  ) : (
                    <span
                      onClick={item.function}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      {item.icon}
                      {item.label}
                    </span>
                  )}
                </S.DropdownItem>
              ))}
          </S.DropdownContent>
        </S.Dropdown>
      </S.DropdownBox>
    </S.BoxDropdownGroup>
  );
};

export default DropdownGroup;
